import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Registration from './components/Registration';
import WhatToExpect from './components/WhatToExpect';
import PreviousYear from './components/PreviousYear';
//import Activities from './components/Activities';
//import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppQR from './components/WhatsAppQR';
import Terms from './components/Terms';
//import GoogleAdsTest from './components/GoogleAdsTest';
//import FirebaseConnectionTest from './components/FirebaseConnectionTest';
import './index.css';

// Internal planning board — lazy-loaded so the public bundle is untouched.
const AdminApp = React.lazy(() => import('./components/admin/AdminApp'));

// Home page component
const HomePage: React.FC = () => {
  return (
    <>
      <Navigation />
      {/*
      Firebase Connection Test - Remove this in production
      <div className="pt-20 pb-8 bg-gray-50">
        <FirebaseConnectionTest />
      </div>
      */}
      <main>
      <section id="hero">
        <Hero />
      </section>
      {/* The 2027 program is not planned yet: the placeholder holds the
          #program anchor; the real 2026 program lives in <PreviousYear />.
          Once the 2027 program is filled in (src/data/programData.ts),
          swap this back to <Program programs={campPrograms} …/>. */}
      <section id="program">
        <WhatToExpect />
      </section>
      <section id="registration">
        <Registration />
      </section>
      {/*
      <section id="faq">
        <FAQ />
      </section>
      */}
      {/* Activities Section 
      <section id="activities">
        <Activities />
      </section>
      */}
      <section id="contact">
        <Contact />
      </section>
      <PreviousYear />
      </main>
      <Footer />
      
      {/* Google Ads Testing Component - Remove in production */}
      {/*process.env.NODE_ENV === 'development' && <GoogleAdsTest />*/}
    </>
  );
};

const App: React.FC = () => {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/whatsapp" element={<WhatsAppQR />} />
          <Route path="/noteikumi" element={<Terms />} />
          <Route
            path="/admin/*"
            element={
              <React.Suspense
                fallback={
                  <div className="min-h-screen flex items-center justify-center text-gray-400">
                    Ielādē…
                  </div>
                }
              >
                <AdminApp />
              </React.Suspense>
            }
          />
        </Routes>
      </Router>
    </div>
  );
};

export default App;
